<template>
  <div class="hd-type-03">
    <h3 data-test="title">
      {{ title }}
    </h3>
  </div>
</template>

<style scoped lang="scss">
@use "@/styles/preview/pc/offer/base" as *;
</style>

<script>
export default {
  props: {
    title: {
      type: String,
      required: true
    }
  }
}
</script>
